/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputGeoTraceStep
 */
export interface OutputGeoTraceStep {
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceStep
     */
    corridorCost?: number;
    /**
     * CumulativeCost — сума вартості гіпотези після цього кроку.
     * @type {number}
     * @memberof OutputGeoTraceStep
     */
    cumulativeCost?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoTraceStep
     */
    displayName?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceStep
     */
    distCost?: number;
    /**
     * DistKm — до попередньої точки ланцюга; для першої точки — до якоря коридору.
     * @type {number}
     * @memberof OutputGeoTraceStep
     */
    distKm?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceStep
     */
    excessKm?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoTraceStep
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoTraceStep
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceStep
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceStep
     */
    lng?: number;
    /**
     * Merged — крок спожив склеєну дефісну пару (два токени однією назвою).
     * @type {boolean}
     * @memberof OutputGeoTraceStep
     */
    merged?: boolean;
    /**
     * Складові крокової вартості: (1-score) + alpha*dist/100 + alphaCorridor*excess/100.
     * @type {number}
     * @memberof OutputGeoTraceStep
     */
    nameCost?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceStep
     */
    placeId?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceStep
     */
    score?: number;
    /**
     * Skipped — токен свідомо лишено без точки: усі кандидати виявились дорожчими за пропуск
     * (або їх не було). NameCost тоді містить ціну пропуску.
     * @type {boolean}
     * @memberof OutputGeoTraceStep
     */
    skipped?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceStep
     */
    tokenIndex?: number;
}

/**
 * Check if a given object implements the OutputGeoTraceStep interface.
 */
export function instanceOfOutputGeoTraceStep(value: object): boolean {
    return true;
}

export function OutputGeoTraceStepFromJSON(json: any): OutputGeoTraceStep {
    return OutputGeoTraceStepFromJSONTyped(json, false);
}

export function OutputGeoTraceStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoTraceStep {
    if (json == null) {
        return json;
    }
    return {
        
        'corridorCost': json['corridorCost'] == null ? undefined : json['corridorCost'],
        'cumulativeCost': json['cumulativeCost'] == null ? undefined : json['cumulativeCost'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'distCost': json['distCost'] == null ? undefined : json['distCost'],
        'distKm': json['distKm'] == null ? undefined : json['distKm'],
        'excessKm': json['excessKm'] == null ? undefined : json['excessKm'],
        'kind': json['kind'] == null ? undefined : json['kind'],
        'label': json['label'] == null ? undefined : json['label'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'merged': json['merged'] == null ? undefined : json['merged'],
        'nameCost': json['nameCost'] == null ? undefined : json['nameCost'],
        'placeId': json['placeId'] == null ? undefined : json['placeId'],
        'score': json['score'] == null ? undefined : json['score'],
        'skipped': json['skipped'] == null ? undefined : json['skipped'],
        'tokenIndex': json['tokenIndex'] == null ? undefined : json['tokenIndex'],
    };
}

export function OutputGeoTraceStepToJSON(value?: OutputGeoTraceStep | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'corridorCost': value['corridorCost'],
        'cumulativeCost': value['cumulativeCost'],
        'displayName': value['displayName'],
        'distCost': value['distCost'],
        'distKm': value['distKm'],
        'excessKm': value['excessKm'],
        'kind': value['kind'],
        'label': value['label'],
        'lat': value['lat'],
        'lng': value['lng'],
        'merged': value['merged'],
        'nameCost': value['nameCost'],
        'placeId': value['placeId'],
        'score': value['score'],
        'skipped': value['skipped'],
        'tokenIndex': value['tokenIndex'],
    };
}

